var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import $request from '../../utils/request';
var state = {
    loanList: [],
    loanDetail: { loanStatus: -1 },
    customer: {},
    advanceRepayQuery: {},
    creditResult: {},
    // allContractList: {}, // 合同列表
    assets: [],
    loanStepStatus: 0,
    repayList: {},
    showDialog: false,
    advanceRepayQueryFlag: {},
};
var mutations = {
    update: function (state, props) {
        for (var key in props) {
            if (state.hasOwnProperty(key)) {
                state[key] = props[key];
            }
        }
    },
};
var actions = {
    GET_LOAN_LIST: function (_a, params) {
        var state = _a.state, commit = _a.commit, dispatch = _a.dispatch;
        // 查询借款列表
        var showDialog = params.showDialog ? params.showDialog : '';
        delete params.showDialog;
        commit('update', {
            loanDetail: { loanStatus: -1 },
            loanStepStatus: 0,
        });
        $request({
            url: '/proxy/oneCar/api/loan/list',
            method: 'post',
            data: __assign({}, params, { pageNo: 1 }),
        }).then(function (res) {
            if (!res.errorCode) {
                if (params.loanOrderId) {
                    var loanStepStatus = 0;
                    switch (res.data[0].loanStatus) {
                        case 10:
                            loanStepStatus = 1;
                            break;
                        case 20:
                            loanStepStatus = 2;
                            break;
                        case 40:
                            loanStepStatus = 3;
                            break;
                        case 50:
                            loanStepStatus = 4;
                            break;
                        default:
                            loanStepStatus = 0;
                    }
                    commit('update', {
                        loanDetail: res.data[0],
                        loanStepStatus: loanStepStatus,
                    });
                    if (showDialog) {
                        commit('update', {
                            showDialog: true,
                        });
                    }
                    dispatch('GET_CONSTRACT_LIST', {
                        loanOrderId: params.loanOrderId,
                    });
                }
                else {
                    commit('update', {
                        loanList: res.data,
                    });
                }
            }
        });
    },
    GET_CONSTRACT_LIST: function (_a, params) {
        var state = _a.state, commit = _a.commit, dispatch = _a.dispatch;
        // 合同列表
        $request({
            method: 'post',
            url: '/proxy/oneCar/api/loan/contract/list',
            data: __assign({}, params),
        }).then(function (res) {
            if (!res)
                return;
            if (res && !res.errorCode) {
                var assets = res.data.assets;
                assets.forEach(function (asset) {
                    asset.active = false;
                });
                commit('update', {
                    assets: assets,
                });
            }
        });
    },
    GET_CUSTOMER_INFO: function (_a, params) {
        var state = _a.state, commit = _a.commit, dispatch = _a.dispatch;
        // 查询当前商户信息
        $request({
            url: '/proxy/oneCar/api/loan/merchant/info',
            method: 'post',
            data: __assign({}, params),
        }).then(function (res) {
            if (!res.errorCode) {
                commit('update', {
                    customer: res.data,
                });
            }
        });
    },
    ADVANCE_PLAN_QUERY: function (_a, params) {
        var state = _a.state, commit = _a.commit, dispatch = _a.dispatch;
        // 提前还款试算查询
        $request({
            url: '/proxy/oneCar/api/advance/repay/trial/query',
            data: __assign({}, params),
            method: 'post',
        }).then(function (res) {
            if (!res.errorCode) {
                commit('update', {
                    advanceRepayQuery: res,
                    showDialog: true,
                });
            }
            else {
                commit('update', {
                    advanceRepayQueryFlag: res,
                });
            }
        });
    },
    GET_CREDIT_QUERY: function (_a, params) {
        var state = _a.state, commit = _a.commit, dispatch = _a.dispatch;
        // 查询授信结果信息
        $request({
            url: 'oneCar/api/credit/query',
            data: __assign({}, params),
            method: 'post',
        }).then(function (res) {
            if (!res.errorCode) {
                commit('update', {
                    creditResult: res.data,
                });
            }
        });
    },
    GET_REPAY_PLAN: function (_a, params) {
        var state = _a.state, commit = _a.commit, dispatch = _a.dispatch;
        $request({
            url: '/proxy/oneCar/api/repay/plan/query',
            method: 'post',
            data: __assign({}, params),
        }).then(function (res) {
            if (!res.errorCode) {
                commit('update', {
                    repayList: res.data,
                    showDialog: true,
                });
            }
        });
    },
};
export default {
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
};
